export const SleepEfficiencyScreenStyles = {
  buttonWidth: 60,
  buttonOffset: 8,
  buttonIconSize: 70,
  referenceWidth: 1170,
} as const;
